import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';


@Injectable({
  providedIn: 'root'
})
export class DepositService {
  url: string = 'deposits';

  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params)
  }

  getSearchOptions(params: any = {}): Promise<any> {
    params.search_options = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }

  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params)
  }
}